import { useEffect, useState } from "react";
import ContentWrapper from "../../views/components/ContentWrapper";
import { getHelpRequests } from "../../data/dataApi";
import Pagination from "../../views/components/Pagination";
import DataSubMenu from "../../views/components/DataSubMenu";
import { useParams, useNavigate } from "react-router";

const HelpRequests = () => {
    const { page, status } = useParams();

    let statusFilter;
    
    if(status) {
        if(status === "resolved") {
            statusFilter = "Resolved";
        } else if(status === "pending") {
            statusFilter = "Pending";
        } else {
            statusFilter = "All";
        }
    }

    const [helpRequests, setHelpRequests] = useState([]);
    const [activeTab, setActiveTab] = useState(statusFilter || "All");

    const navigate = useNavigate();

    const listLimit = 30;

    const subNavOptions = ["All", "Resolved", "Pending"];

    useEffect(() => {
        (async () => {
            const response = await getHelpRequests(page === undefined ? 0 : page - 1, status || "");

            if(response.success) {
                setHelpRequests(response.data.rows);
            }
        })();
    }, [page, status]);

    useEffect(() => {
        if(activeTab !== "All") {
            let statusPath = "";

            if(activeTab === "Resolved") {
                statusPath = "resolved";
            } else if(activeTab === "Pending") {
                statusPath = "pending";
            }

            navigate(`/help-requests/page/1${ statusPath ? `/${ statusPath }` : '' }`);
        } else {
            navigate("/help-requests");
        }
    }, [activeTab]);

    return(
        <ContentWrapper className="scrollable">
            <DataSubMenu subNavOptions={ subNavOptions } activeTab={ activeTab } setActiveTab={ setActiveTab } />
            <div className="wrapper">
                <div className="table-wrapper">
                    <table className="primary-table">
                        <thead>
                            <tr>
                                <td>ID</td>
                                <td className="message-column">Message</td>
                                <td>Name</td>
                                <td>Email</td>
                                <td>Status</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                helpRequests.map((entry) =>
                                    <tr key={ entry.id } onClick={() => navigate(`/help-requests/${ entry.id }`)}>
                                        <td>{ entry.id }</td>
                                        <td className="message-column text-truncate">{ entry.message }</td>
                                        <td>{ entry.name }</td>
                                        <td>{ entry.email }</td>
                                        <td>{ entry.status === "resolved" ? "Resolved" : "Pending" }</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>

                    <Pagination listLength={ helpRequests.length && helpRequests[0].total_count } page={ page } path="/help-requests" filter={ status } limit={ listLimit } />
                </div>
            </div>
        </ContentWrapper>
    );
};

export default HelpRequests;